export default __webpack_public_path__ + "static/media/krazy1.099735a0.png";